import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainView } from 'app/views/main/main.component';
import { MasterService } from 'app/services/master/master.service';
import { AppRoutingModule } from 'app/app.routing';

@NgModule({
    imports: [CommonModule, AppRoutingModule],
    declarations: [MainView],
    providers: [MasterService],
    exports: [MainView]
})
export class MainViewModule { }



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/main/main.module.ts